/* eslint-disable @typescript-eslint/naming-convention */
import { AsComponentProps } from '../../types/module';
export enum NumberEmployeeRangeEnum {
  '1-3',
  '4-9',
  '10-24',
  '25+',
  '25-49', // ONLY FOR PREMIUM PACKAGE
  '50-149', // ONLY FOR PREMIUM PACKAGE
}

export enum PayfitPackageEnum {
  'Paie',
  'Paie Avancée',
  'RH+',
  'Premium',
}

export interface FullResultsCalculatorProps {
  title?: string;
  subtitle?: string;
  cta?: { label: string; href?: string; to?: string; as?: AsComponentProps };
}

export interface PayFitPackages {
  numberEmployeeRange: NumberEmployeeRangeEnum;
  payfitPackage: PayfitPackageEnum;
  subscription: number;
  subscriptionByPayroll: number;
  kanoonPrice: number;
  expenseModule: number;
}

export interface SimplifiedSimulatorValues {
  label: string;
  value: string;
}

export type PackageObject = {
  [key in any]: number;
};

export interface simulatorInputs {
  y1: {
    numberEmployee: number;
    package: PayfitPackageEnum;
    numberEmployeeRange: NumberEmployeeRangeEnum;
    expenseModule: boolean;
  };
  y2: {
    numberEmployee: number;
    package: PayfitPackageEnum;
    numberEmployeeRange: NumberEmployeeRangeEnum;
    expenseModule: boolean;
  };
  y3: {
    numberEmployee: number;
    package: PayfitPackageEnum;
    numberEmployeeRange: NumberEmployeeRangeEnum;
    expenseModule: boolean;
  };
}
